<div class="home-page">
<div class="logo">
    <img src="/assets/images/logo-prefeitura.svg" alt="logo da prefeitura" />
    <img src="/assets/images/logo-seplaf.svg" alt="logo da seplaf" />
</div>
<div class="title">
  <span class="box">CONSULTA PÚBLICA</span>
  <div class="title-main-text"> <span class="P-strong">Planejamento</span>
    <span class="desktop-br"><br/></span> <span class="O-italic">Orçamentário</span>
  </div>
</div>
<div class="cards">
 @for (item of cards; track $index) {
    <app-categorie-card [card] = item />
 }
</div>
<p class="ter-italic">
  Transparência, eficiência e responsabilidade na <br/>
  gestão financeira de Parnamirim
</p>
<div class="contact-card">
<app-contact-card/>
</div>
<div>
  <div class="img-1">
   <img src="../../../../../assets/images/img-paint.svg" class="scattered-img" id="img-1" alt="">
   </div>
   <div class="img-2">
   <img src="../../../../../assets/images/img-shove.svg" class="scattered-img" id="img-2" alt="">
   </div>
   <div class="img-3">
   <img src="../../../../../assets/images/img-van.svg" class="scattered-img" id="img-3" alt="">
   </div>
   <div class="img-4">
   <img src="../../../../../assets/images/img-guard.svg" class="scattered-img" id="img-4" alt="">
    </div>
   <div class="img-5" >
    <img src="../../../../../assets/images/img-auditorium.svg" class="scattered-img" id="img-5" alt="">
   </div>
   <div class="img-6">
    <img src="../../../../../assets/images/img-reception.svg" class="scattered-img" id="img-6" alt="">
   </div>
   <div class="img-7">
    <img src="../../../../../assets/images/img-truck.svg" class="scattered-img" id="img-7" alt="">
    </div>
  </div>
  @if (isModalOpen) {
    <app-modal-popup (close)="isModalOpen = false"></app-modal-popup>
  }
<router-outlet />
</div>
